import React, {FC} from "react";
import SpaceUsageCard from "../deprecatedUikit/SpaceUsageCard/SpaceUsageCard";
import SpaceUsageLoader from "../deprecatedUikit/SpaceUsageCard/SpaceUsageLoader";
import {BookingTransactionType, BookingTransactionTypeLabel} from "../constants/securspace-constants";
import {formatCurrencyValue} from "../../util/PaymentUtils";
import {Grid} from "@mui/material";
import {generateSupplierInvoicesLinkFromTransaction} from "../../util/LinkUtils";

const LoadingSkeleton = () => {
  return (
    <Grid container direction={'column'} gap={2}>
      {Array.from({length: 10}).map((_, index) => <SpaceUsageLoader key={index} />)}
    </Grid>
  );
};

interface IPayoutTransactionListProps {
  loading: boolean;
  payoutTransactions: {
    transactionNumber: string;
    payoutAmount: number;
    transactionType: keyof typeof BookingTransactionType;
    serviceDates: string;
    paymentDate: string;
    buyerCompanyName: string;
    locationName: string;
    orderNumber: string;
    paymentType: string;
  }[];
}

const PayoutTransactionList: FC<IPayoutTransactionListProps> = ({loading, payoutTransactions = []}) => {

  return (
    loading ? <LoadingSkeleton /> : payoutTransactions?.map((bookingTransaction) =>
      <SpaceUsageCard
        data={{
          // @ts-expect-error TODO: fix typing in securspace-ui-kit
          invoiceNumber: bookingTransaction.transactionNumber,
          payoutAmount: formatCurrencyValue(bookingTransaction.payoutAmount),
          chargeType: BookingTransactionTypeLabel[bookingTransaction.transactionType],
          serviceDates: bookingTransaction.serviceDates,
          paymentDate: bookingTransaction.paymentDate,
          buyer: bookingTransaction.buyerCompanyName,
          location: bookingTransaction.locationName,
          bookingNumber: bookingTransaction.orderNumber,
          paymentType: bookingTransaction.paymentType,
        }}
        variant={'primary'}
        key={bookingTransaction.transactionNumber}
        // TODO: Update link generation to include date range if needed
        links={{
          // @ts-expect-error TODO: createdOn is not a field of payout transaction, either add it to the api response or edit this link generation
          invoiceNumber: {baseUrl: `${generateSupplierInvoicesLinkFromTransaction(null, bookingTransaction?.createdOn)}&`, queryParam: "invoiceNumber"},
          bookingNumber: {baseUrl: '/bookings/supplier-bookings', queryParam: "bookingNumber"},
      }}
        styles={{ mb: 2, width: '100%'}}
      />
    )
  );
};

export default PayoutTransactionList;
